<script setup>
import CFButton from '@/ui/Button/CFButton.vue';
import CFIcon from '@/ui/Icon/CFIcon.vue';

defineProps({
    domain: {
        type: Object,
        required: true,
    },
    selectedDomain: {
        type: [Object, null],
        required: true,
    },
});

const emit = defineEmits(['select']);
</script>

<template>
    <div class="flex items-center gap-4 border-b border-black py-4">
        <span
            class="flex size-4 shrink-0 items-center justify-center rounded-full"
            :class="[selectedDomain === domain ? 'bg-accent' : 'bg-neutrals-400']"
        >
            <CFIcon
                v-show="selectedDomain === domain"
                name="arrow-right"
                class="size-3 text-white"
            />
        </span>
        <span class="grow underline underline-offset-3 select-none">
            {{ domain.attributes.name + '.' + domain.attributes.tld }}
        </span>
        <CFButton
            type="button"
            size="sm"
            class="shrink-0"
            :color="selectedDomain === domain ? 'accent' : 'primary'"
            :icon="selectedDomain === domain ? 'check' : null"
            :outline="selectedDomain !== domain"
            @click="emit('select')"
        >
            <span v-if="selectedDomain !== domain">{{ $t('button.select') }}</span>
            <span v-else>{{ $t('button.selected') }}</span>
        </CFButton>
    </div>
</template>
